import { Directive, ElementRef, Inject, AfterViewInit, DOCUMENT } from '@angular/core';

@Directive({
  selector: '[ecpDynamicStickyNoteScript]',
  standalone: false,
})
export class DynamicStickyNoteScriptDirective implements AfterViewInit {
  constructor(private el: ElementRef, @Inject(DOCUMENT) private document: Document) {}

  ngAfterViewInit() {
    const templateEl = this.el.nativeElement.firstElementChild as HTMLElement;
    if (templateEl) {
      this.replaceDivWithScript(templateEl);
    }
  }

  private replaceDivWithScript(templateEl: HTMLElement) {
    const script = this.document.createElement('script');
    script.src = `assets/js/dynamic-sticky-note-script.js`;

    templateEl.remove();

    // add the new script element to the host div so the browser will execute it
    this.el.nativeElement.appendChild(script);
  }
}
